import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { Admincontent2, AdminContext } from '../../../../containers/Admin';
import { Input } from '../../../../ui/form/Input';
import { Button } from '../../../../ui/button/Button';
import { ButtonGroup } from '../../../../ui/button/ButtonGroup';

import ImageUploading, {
    ImageListType,
    ImageType,
} from 'react-images-uploading';

//form
import { Editor, EditorForm, InputElement } from '../EditorForm';

//update
import { getUploadClient } from '../../AdminApolloClient';
import { gql, useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { UPDATE_IMAGE } from '../../../../../../client/__graphql__/mutations/upload/updateImage';
import { H2 } from '../../../HeaderTitle';
import { ValidUrlInput } from '../../../../../utils/helpers/url';
import { checkOfficeTag } from '../../../../../utils/helpers/checkOfficeTag';
import { replaceAll } from '../../../../../utils/seo/utils';

const up_client = getUploadClient();

export interface ImageData {
    id: number,
    key: string,
    title: string,
    description: string,
    link: string
    image: string
}

export const ImageForm = React.memo((props: { image: ImageData, content_type: any; urltag: string, upload: boolean, style?: any, onCancel?: any }) => {
    const [images, setImages] = React.useState([]);
    const [maxImages, SetMaxNumber] = React.useState(1);
    const [imgData, setImageData] = useState(props.image);
    const [showUpload, setShowUpload] = useState(props.upload);
    const [contentType, setContentType] = useState(props.content_type);
    const [is_disabled, SetIsDisabled] = useState(props?.image && props?.image?.image ? false : true);
    const [valid_url, SetValidUrl] = useState(ValidUrlInput(props?.image?.link));
    const history = useHistory();

    //const history = useHistory();
    const context = useContext(AdminContext);

    const [submit, { error: submitError, loading: submitLoading, data: submitData },] = useMutation(UPDATE_IMAGE, {
        client: up_client,
        onCompleted: (data: any) => {
            if (data?.updateImage?.key) {
                setImageData({
                    ...imgData,
                    ['id']: data?.updateImage?.id,
                    ['key']: data?.updateImage?.key,
                    ['image']: data?.updateImage?.url
                });
            }

            if (data?.updateImage?.result) {
                alert('Bildet har blitt oppdatert!');
                setShowUpload(false);
                SetIsDisabled(false);
            }
            else {
                alert('Bildet ble ikke oppdatert!');
            }
        },
    });

    const handleSubmit = (e: any) => {
        e.preventDefault();
        if (valid_url) {
            const file = GetUploadImage();
            submit({
                variables: {
                    input: {
                        image_id: imgData?.key,
                        article_id: 0,
                        type: contentType?.type,
                        urltag: checkOfficeTag(props.urltag),
                        title: imgData?.title,
                        description: CleanText(imgData?.description),
                        link: imgData?.link,
                    },
                    file,
                },
            });
        }
        else {
            alert('Lenke er ugyldig!');
        }
    };

    const CleanText = (val: string | null | undefined) => {
        if (val && val.trim().length > 0) {
            val = replaceAll(val, '\r', '');
            val = replaceAll(val, '\n', '<br />');
        }

        return val;
    }

    const GetUploadImage = (): ImageType | null => {
        if (showUpload && images && images.length > 0 && images[0]) {
            var img = images[0] as ImageType;
            if (img && img?.file) {
                return img?.file;
            }
        }

        return null;
    };

    //upload image functions
    const onImageChange = (imageList: ImageListType, addUpdateIndex: number[] | undefined) => {
        setImages(imageList as never[]);
        SetIsDisabled(imageList && imageList.length > 0 ? false : true);
    };

    const onKeepCurrentImage = () => {
        setShowUpload(false);
        SetIsDisabled(false);
    };

    const onDeleteCurrentImage = () => {
        setShowUpload(true);
        SetIsDisabled(true);
    };

    //default functions
    const onChange = (e: any) => {
        setImageData({
            ...imgData,
            [e.target.name]: e.target.value,
        });

        if (e?.target?.type?.toLowerCase() == "url") {
            SetValidUrl(e?.target?.validity?.valid ? true : false);
        }
    };

    if (!context.adminState.loggedIn.status) {
        return <div></div>;
    }

    return (
        <>
            <Admincontent2>
                <EditorH2>{imgData?.id > 0 ? 'Last opp bilde' : 'Rediger bilde'}</EditorH2>
                <Editor style={props.style}>
                    <form>
                        {showUpload ? (
                            <ImageUploading
                                multiple
                                value={images}
                                onChange={onImageChange}
                                maxNumber={maxImages}
                            >
                                {({
                                    imageList,
                                    onImageUpload,
                                    onImageRemoveAll,
                                    onImageUpdate,
                                    onImageRemove,
                                    isDragging,
                                    dragProps,
                                }) => (
                                    // UI here
                                    <ImagesUploadingStyle>
                                        <ButtonWrap>
                                            {!(images && images.length >= maxImages) ? (
                                                <Button
                                                    style={
                                                        isDragging ? { color: '#4B4B4B' } : undefined
                                                    }
                                                    type="primary"
                                                    colorTheme="gold"
                                                    onClick={onImageUpload}
                                                    {...dragProps}
                                                >
                                                    Velg bilde
                                                </Button>
                                            ) : null}
                                            {images && images.length > 1 ? (
                                                <Button
                                                    id="btn_remove"
                                                    type="primary"
                                                    onClick={onImageRemoveAll}
                                                    colorTheme="gray"
                                                >
                                                    Fjern alle bildene
                                                </Button>
                                            ) : null}
                                            {imgData && imgData?.id > 0 && imgData?.image ? (
                                                <Button
                                                    id="btn_img_cancel"
                                                    type="primary"
                                                    colorTheme="gray"
                                                    onClick={onKeepCurrentImage}
                                                >
                                                    Behold forrige bilde
                                                </Button>
                                            ) : null}
                                        </ButtonWrap>
                                        {imageList.map((image, index) => (
                                            <ImageDiv key={index}>
                                                <img src={image.dataURL} alt="" />
                                                <ButtonGroup position="right">
                                                    <Button
                                                        onClick={() => onImageRemove(index)}
                                                        type="primary"
                                                        colorTheme="gray"
                                                    >
                                                        Slett
                                                    </Button>
                                                </ButtonGroup>
                                            </ImageDiv>
                                        ))}
                                    </ImagesUploadingStyle>
                                )}
                            </ImageUploading>
                        ) :
                            (<ImageDiv>
                                <img src={imgData.image} alt="" />
                                <ButtonGroup position="right">
                                    <Button onClick={onDeleteCurrentImage} type="primary" colorTheme="gray" >
                                        Slett/Bytt bilde
                                    </Button>
                                </ButtonGroup>
                            </ImageDiv>)
                        }

                        <InputElement>
                            <h2>Tittel</h2>
                            <Input
                                name="title"
                                value={imgData?.title ? imgData?.title : ''}
                                onChange={onChange}
                            />
                            <div style={{ marginBottom: '18px' }}></div>
                        </InputElement>
                        <InputElement>
                            <h2>Lenke</h2>
                            <Input
                                name="link"
                                type="url"
                                pattern="http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w\- .\/?%&=]*)?"
                                value={imgData?.link ? imgData?.link : ''}
                                onChange={onChange}
                            />
                            <div style={{ marginBottom: '18px' }}></div>
                        </InputElement>
                        <InputElement>
                            <h2>Beskrivelse</h2>
                            <TextArea
                                name="description"
                                value={imgData?.description ? replaceAll(imgData?.description, '<br />', '\n') : ''}
                                onChange={onChange}
                            />
                            <div style={{ marginBottom: '18px' }}></div>
                        </InputElement>
                        <EditButtonWrapper>
                            {props.onCancel ? (
                                <Button type="primary" onClick={props.onCancel} colorTheme="gold"    >
                                    Avbryt
                                </Button>
                            ) : null}
                            <Button onClick={handleSubmit} type="primary" colorTheme={is_disabled ? "gray" : "gold"} disabled={is_disabled} >
                                {showUpload ? 'Last opp bilde' : 'Oppdater'}
                            </Button>
                        </EditButtonWrapper>
                    </form>
                </Editor>
            </Admincontent2 >
        </>);
},
    (prevState, nextState) =>
        prevState.image?.id === nextState.image?.id
);

const ImageDiv = styled.div`
  margin-bottom: 15px;
  margin-top: 15px;

  img {
      width: 100%;
  }
`;

const TextArea = styled.textarea`
    display: block;
    padding: 15px;
    width: 100%;
    max-width: 100%;
    background: ${({ theme }) => theme.input.background};
    font-size: ${(props) => props.theme.input.font.size};
    font-weight: 400;
    color: white;
    border: ${(props: any) =>
        props.error
            ? `solid 2px ${props.theme.input.error}`
            : 'solid 2px transparent'};
    outline: none;
    border-radius: 0;

    &:focus {
        outline: none;
    }
    &::-webkit-input-placeholder {
        color: ${(props: any) => props.theme.input.placeholder};
    }
    :not(:valid){
        background: ${({ theme }) => theme.input.error};
    }
    height:250px;
`;

export const EditorH2 = styled(H2)`
  padding: 10px 0px;
  margin: 0 auto;
`;

export const EditButtonWrapper = styled.div`
  margin-top: 12px;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  button {
      :not(:last-child) {
          margin-right: 15px;
      }
  }
`;

const ImagesUploadingStyle = styled.div`
  width: 100%;
`;

const ButtonWrap = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding-bottom: 20px;

  button {
    float: right;

    :not(:first-child) {
      margin-left: 15px;
    }
  }
`;

export default ImageForm;
